/**
 * Niet in het origineel: wie er als spelleider is ingelogd, voor alles onder `/admin`.
 * `AlleenSpelleider` vult de context; daarbinnen is er altijd een spelleider.
 */
import { createContext, useContext } from 'react';
import type { Spelleider } from '@ame/shared';

export type Sessie = {
  spelleider: Spelleider;
  /** Beëindigt de sessie op de server; daarna verschijnt het inlogscherm. */
  uitloggen: () => Promise<void>;
  /** Vraagt opnieuw op wie er is ingelogd, bijvoorbeeld na een wijziging van de naam. */
  opnieuwLaden: () => Promise<void>;
};

export const SessieContext = createContext<Sessie | null>(null);

/** De ingelogde spelleider; alleen te gebruiken onder `AlleenSpelleider`. */
export function useSpelleider(): Sessie {
  const sessie = useContext(SessieContext);
  if (!sessie) throw new Error('useSpelleider werkt alleen onder AlleenSpelleider.');
  return sessie;
}
